import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { HeaderComponent } from './pages/Layout/header/header.component';
import { LoaderComponent } from '@shared/loader/loader.component';
import {
  trigger,
  transition,
  style,
  query,
  group,
  animate,
} from '@angular/animations';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { SharedService } from '@services/shared.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { OtpmodalComponent } from '@shared/otpmodal/otpmodal.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { filter, map, mergeMap } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { NotificationsService } from '@services/notifications.service';
import { AuthService } from './Auth/AuthService';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NzIconModule,
    NzLayoutModule,
    NzMenuModule,
    NzAlertModule,
    NzModalModule,
    LoaderComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('routeAnimations', [
      transition('* <=> *', [
        style({ position: 'relative' }),
        query(
          ':enter, :leave',
          [
            style({
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
            }),
          ],
          { optional: true }
        ),
        group([
          query(':leave', [animate('700ms ease-out', style({ opacity: 0 }))], {
            optional: true,
          }),
          query(
            ':enter',
            [
              style({ opacity: 0 }),
              animate('700ms ease-out', style({ opacity: 1 })),
            ],
            { optional: true }
          ),
        ]),
      ]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  isIframe = false;
  isDashboard = false;
  actionTemplateMap: { [key: string]: TemplateRef<any> } = {};
  subscriptionTemplate!: TemplateRef<any>;
  @ViewChild('subscriptionTemplate', { static: true })
  verifyTemplate!: TemplateRef<any>;
  hiddenAlertIds = new Set<number>();

  @ViewChild('verifyTemplate', { static: true })
  router = inject(Router);
  sharedService = inject(SharedService);
  modal = inject(NzModalService);
  activatedRoute = inject(ActivatedRoute);
  titleService = inject(Title);
  notificationsService = inject(NotificationsService);
  authService = inject(AuthService);

  constructor() {
    // Subscribe to dashboard mode changes
    this.sharedService.isDashboard$.subscribe(value => {
      this.isDashboard = value;
    });
  }

  ngOnInit(): void {
    // Log build version info (only visible in developer console)
    console.log(`%c🚀 Luqta App Version: ${environment.appVersion}`, 'color: #4CAF50; font-weight: bold;');

    // ✅ Detect hash in URL and redirect to 404
    if (window.location.hash && window.location.hash.length > 1) {
      window.location.href = window.location.origin + '/not-found';
      return;
    }


    this.setpagetitle()
    this.isIframe = window !== window.parent && !window.opener;

    this.actionTemplateMap = {
      subscription: this.subscriptionTemplate,
      verify: this.verifyTemplate,
    };
    this.sharedService.alerts$.subscribe((alerts) => {
      alerts.forEach((alert) => {
        if (!this.hiddenAlertIds.has(alert.id)) {
          setTimeout(() => {
            this.hiddenAlertIds.add(alert.id);
          }, 5000);
        }
      });
    });

    // Initialize Pusher real-time notifications if user is logged in
    if (this.authService.isLoggedIn()) {
      this.initializePusherNotifications();
    }
  }

  /**
   * Initialize Pusher for real-time notifications with filtering
   */
  private initializePusherNotifications(): void {
    try {
      // Initialize Pusher with your configuration
      this.notificationsService.initPusher(
        '9fdb617d0710768bc9f5',  // Your Pusher app key from the HTML example
        'ap2',                     // Your cluster
        'luqta'                    // Your channel name
      );
    } catch (error) {
      console.error('❌ Failed to initialize Pusher:', error);
    }
  }

  /**
   * Clean up Pusher connection when component is destroyed
   */
  ngOnDestroy(): void {
    this.notificationsService.disconnectPusher();
  }
  setpagetitle() {
    this.router?.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const pageTitle = data['title'] ? data['title'] : 'Default';
        this.titleService.setTitle(`Luqta | ${pageTitle}`);
      });
  }
  getRouteAnimationData(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData;
  }

  showAlerts(alert: any) {
  }

  hideAlert(id: number): void {
    this.hiddenAlertIds.add(id);
  }
}
